import React from "react";
import DetailAnggota from "../../components/organism/DetailOverviewAnggota";
const PageDetailAnggota = () => {
  return (
    <>
      <DetailAnggota />
    </>
  );
};

export default PageDetailAnggota;
